import { AssetService } from '../model/asset.service';
import { CrudDataSource, HateoasMultipleResponseObject, PageSpecification } from '@scisys-uim/uim-common';
import { Asset } from 'assets-model';
import { Observable } from 'rxjs';


export class AssetDataSource extends CrudDataSource<Asset> {

  constructor(private service: AssetService) {
    super();
  }

  protected callLoaderService(serviceArguments: any, pageSpec: PageSpecification): Observable<HateoasMultipleResponseObject<Asset>> {
    return this.service.findByFullFilters(serviceArguments, pageSpec);
  }

}


